import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import './report-an-issue.css'
import { bulkDeleteApi, getDeleteAdminApi, getDeleteApi } from "../masters/master-api";
const DeleteModal = ({ deleteUrl, isAdmin = false, ids, onSuccess, onCancel }) => {

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,

    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "40px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 1)",
      width: "436px",
      height: "228px",
      textAlign: "center",
    },
  };


  const deleteApi = async () => {
    if (deleteUrl != null && ids == null) {
      try {
        let response;
        if (isAdmin) {
          response = await getDeleteAdminApi(deleteUrl);
        } else {
          response = await getDeleteApi(deleteUrl);
        }



        if (response?.status === 200 || response?.status === 500) {
          /*  if (response.data.success === true) { */
          onSuccess(response.data)
          /* }   */
        }
        return response.data;
      } catch (err) {

        console.error("Error fetching category:", err);
      } finally {
      }
    }
    if (deleteUrl != null && ids.length > 0) {
      try {
        const response = await bulkDeleteApi(deleteUrl, ids);
        if (response?.status === 200 || response?.status === 500) {
          /*  if (response.data.success === true) { */
          onSuccess(response.data)
          /* }   */
        }
        return response.data;
      } catch (err) {

        console.error("Error fetching category:", err);
      } finally {
      }
    }
  };
  return (<div style={modalStyle.overlay} backdrop="static">
    <div style={modalStyle.modal}>
      <div style={{ color: '#ffffff' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
          <div style={{ fontSize: "20px", fontWeight: "700", color: '#1E1E1E' }}>Delete </div>
          <div style={{ marginTop: '8px', fontSize: "16px", fontWeight: "400", color: '#1E1E1E' }}>You won’t able to access your record after deleting. Are you sure want to delete?</div>

          <div style={{ flex: 12, marginTop: '8px', display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start', }}>
            <div onClick={onCancel} style={{ cursor: 'pointer', width: '158px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '8px', display: 'flex', flex: 6, justifyContent: "center", alignItems: "center", border: "1px solid #E5E5E5", }}>
              <div style={{ fontSize: "16px", fontWeight: "500", color: '#1E1E1E' }}>Cancel</div>
            </div>
            <div onClick={() => {
              deleteApi();
            }} style={{ cursor: 'pointer', width: '158px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '8px', display: 'flex', flex: 6, justifyContent: "center", alignItems: "center", background: "#FF4444", }}>
              <div style={{ fontSize: "16px", fontWeight: "500", color: '#FFFFFF' }}>Delete</div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>);

}

export default DeleteModal;